import { render, staticRenderFns } from "./BotaoDashboardMonitoramentoOperacoes.vue?vue&type=template&id=ffb0dfc4&lang=pug"
import script from "./BotaoDashboardMonitoramentoOperacoes.vue?vue&type=script&lang=js"
export * from "./BotaoDashboardMonitoramentoOperacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports